import { styled } from "styled-components";

export const MemberHistoryWrapper = styled.div`
  position: absolute;
  z-index: 1000;
  background: #fff;
  width: 484px;
  height: 658px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 13px;
  padding: 40px;
  box-sizing: border-box;

  > .list-wrapper {
  }
`;

export const MemberHistoryHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;

  > .back {
    cursor: pointer;
    width: 11.74px;
    height: 11.74px;

    > .img {
      width: 100%;
      height: 100%;
    }
  }
`;

export const MemberHistoryInfoHeader = styled.div`
  display: flex;
  gap: 10px;
  flex-direction: column;
  align-items: flex-end;
  margin-bottom: 9px;

  > div {
    font-family: Pretendard;
    font-size: 11px;
    font-weight: 500;
    line-height: 13.13px;

    > span {
      font-weight: 700;
    }
  }
`;

export const MemberHistoryHeaderRow = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;

  > div {
    font-family: Pretendard;
    font-size: 11px;
    font-weight: 500;
    line-height: 13.13px;
  }
  span {
    font-weight: 700;
  }
`;

export const MemberHistoryInfoHeaderPay = styled.div`
  display: flex;
  gap: 5px;

  .more {
    position: relative;
    width: 14px;
    height: 14px;
    cursor: pointer;

    > img {
      width: 100%;
      height: 100%;
    }
  }
`;

export const MemberHistoryListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  height: 440px;
`;

export const MemberHistoryListItem = styled.div`
  background: #ecf0f3;
  height: 40px;
  padding: 0px 15px 0px 15px;
  border-radius: 11.47px;
  display: flex;
  font-family: Pretendard;
  font-size: 11px;
  font-weight: 500;
  text-align: center;
  align-items: center;

  > .a {
    width: 40%;
  }
  > .b {
    width: 30%;
    display: flex;
    gap: 5px;
    align-items: center;
    justify-content: center;

    .more {
      position: relative;
      width: 14px;
      height: 14px;
      cursor: pointer;

      > img {
        width: 100%;
        height: 100%;
      }
    }
  }

  > .item {
    width: 20%;

    > span {
      padding: 5px 17.5px;
      border-radius: 6px;
      background: #d91818;
      color: #fff;
      cursor: pointer;
    }
  }
`;
